import React from 'react';
import PropTypes from 'prop-types';
import { publish } from '@wh/message-bus';
import { DrawerItem, IconAsset } from '@sitebase/web-shell-kit';
import { LINK_RENDERER_TYPE } from '../../rendererTypes';
import { SUB_NAV_MENU_EVENT_TOPIC } from './../../topics';

const preventLinkClickDefault = (e) => e && e.preventDefault();

const onClick = (data) => (event) => {
  preventLinkClickDefault(event);
  publish({ topic: SUB_NAV_MENU_EVENT_TOPIC, data });
};

function LinkMenu(props) {
  const { id, label, icon, link } = props;
  return (
    <DrawerItem
      id={id}
      icon={icon ? <IconAsset name={icon} /> : undefined}
      {...link}
      data-test-id={`${LINK_RENDERER_TYPE}_${id}`}
      onClick={onClick(props)}
    >
      {label}
    </DrawerItem>
  );
}

LinkMenu.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  link: PropTypes.shape({
    url: PropTypes.string,
    target: PropTypes.string,
  }),
};

// eslint-disable-next-line react/prop-types
const renderFunction = ({ data }) => <LinkMenu key={data.id} {...data} />;

const buildLinkMenuRenderer = () => ({
  type: LINK_RENDERER_TYPE,
  render: renderFunction,
  schema: {},
});

const LinkMenuRenderer = buildLinkMenuRenderer();

export default LinkMenuRenderer;
